define([
    "./temperatureRangeConfigModule",
    "./temperatureRangeConfigRouter",
    "./edition/TemperatureRangeConfigEditionController",
    "./nlgTemperatureRangeConfig",
    "./search/TemperatureRangeConfigSearchController"
], function () {
});